import React, { Component } from 'react'
import PropTypes from 'prop-types'
import features from '../features'
import tracker from '../../../utils/tracker'
import { StoresHeader } from './header'
import StoreList from './store-list/StoreList'
import { scrollTo } from '../../containers/bada/utils'

class FullSelection extends Component {
  constructor(props) {
    super(props)
    this.state = {
      currentTab: 'near',
      toggleAddressChange: false,
    }
  }

  onAddressChange(selectedAddress) {
    if (selectedAddress.postalCode || !features.requireCustomerAddress) {
      this.setState({ toggleAddressChange: false })
      tracker.trackClick('BADA 2.0 search store', 'search other store')

      this.props.onChange({
        selectedAddress,
        selectedStore: null,
        selectedSlot: null,
      })
      scrollTo('store-list')
    }
  }

  render() {
    const {
      stores,
      loading,
      error,
      onChange,
      fallbackAddress,
      selectedAddress,
      selectedCity,
      selectedStore,
      selectedStoreUnavailable,
    } = this.props
    const { toggleAddressChange } = this.state
    const { currentTab } = this.state
    const hasSelectedAddress =
      !!selectedAddress?.latitude ||
      !!selectedAddress?.postalCode ||
      fallbackAddress?.latitude
    return (
      <>
        <StoresHeader
          currentTab={currentTab}
          fallbackAddress={fallbackAddress}
          selectedAddress={selectedAddress}
          selectedCity={selectedCity}
          changeTab={(id) => {
            this.setState({ currentTab: id, selectedStore: null })
            onChange({
              selectedStore: null,
              selectedService: null,
              selectedSlot: null,
            })
          }}
          selectedStoreUnavailable={selectedStoreUnavailable}
          hasSelectedAddress={hasSelectedAddress}
          toggleAddressChange={toggleAddressChange}
          onChange={onChange}
          onAddressChange={(address) => this.onAddressChange(address)}
          storesCount={stores.length}
          toggleAddress={() => {
            onChange({
              selectedStore: null,
              selectedService: null,
              selectedSlot: null,
            })
            this.setState({
              toggleAddressChange: !toggleAddressChange,
            })
          }}
        />
        <StoreList
          stores={stores}
          currentTab={currentTab}
          loading={loading}
          error={error}
          onChange={onChange}
          selectedAddress={selectedAddress}
          selectedStore={selectedStore}
          toggleAddressChange={false}
          hasSelectedAddress={hasSelectedAddress}
        />
      </>
    )
  }
}

FullSelection.propTypes = {
  loading: PropTypes.bool,
  error: PropTypes.bool,
  fallbackAddress: PropTypes.shape({
    postalCode: PropTypes.string,
    city: PropTypes.string,
  }),
  selectedAddress: PropTypes.shape({
    postalCode: PropTypes.string,
    addressLine1: PropTypes.string,
    addressLine2: PropTypes.string,
    addressLine3: PropTypes.string,
    city: PropTypes.string,
    countryName: PropTypes.string,
  }),
  selectedCity: PropTypes.string,
  selectedStore: PropTypes.shape({
    address: PropTypes.string,
    id: PropTypes.string,
    storeManagerId: PropTypes.string,
    storeName: PropTypes.string,
  }),
  stores: PropTypes.arrayOf(PropTypes.shape()),
  onChange: PropTypes.func.isRequired,
}

FullSelection.defaultProps = {
  fallbackAddress: null,
  selectedAddress: null,
  selectedStore: null,
  selectedCity: null,
  loading: false,
  error: false,
  stores: [],
  isMobile: false,
}

export default FullSelection
